<template>
    <div>
        <UtilsContent @close-action="closeDictionary">
            <template v-slot:header>
                <div class="d-flex flex-column justify-center align-start">
                    <div class="d-flex flex-row justify-start align-center mx-3 mb-4">
                        <img :src="dictionaryImg" class="img-index mr-2" alt="" />
                        <span class="text-h5 ma-0 text--primary">
                            {{ $t('bookReading.dictionary') }}
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <div class="d-flex flex-column mx-3">
                    <v-row justify="start" align="start">
                        <v-col cols="12">
                            <v-text-field
                                data-cy="dictionary-input-text"
                                :label="$t('bookReading.dictionary_msg_1')"
                                outlined
                                class="white"
                                color="primary"
                                hide-details
                                clearable
                                @click:clear="clear"
                                v-model="st.word"
                            />
                        </v-col>
                    </v-row>
                    <v-row
                        data-cy="dictionary-content-results"
                        justify="start"
                        align="start"
                        v-if="dictionary_data.length"
                        class="dictionary-content"
                    >
                        <v-col cols="12" v-for="(meaning, index) of dictionary_data" :key="index">
                            <MeaningItem :data="meaning" />
                        </v-col>
                    </v-row>
                    <v-row v-if="noMeaning">
                        {{ $t('bookReading.no_meaning') }}
                    </v-row>
                    <v-row v-if="notAvailable">
                        {{ $t('bookReading.not_available') }}
                    </v-row>
                </div>
            </template>
            <template v-slot:actions>
                <v-row justify="center" align="center" v-if="!dictionary_data.length">
                    <v-btn
                        data-cy="dictionary-search-button"
                        color="secondary"
                        rounded
                        class="mt-4 mx-3 w-90 py-5 white--text"
                        :loading="btnLoading"
                        @click="search"
                    >
                        {{ $t('bookReading.search_word') }}
                    </v-btn>
                </v-row>
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState, mapActions } from 'vuex';
import * as Sentry from '@sentry/vue';
import global from '@/constants/GlobalConstant';
import UtilsContent from '@/components/core/utils/UtilsContent.vue';
import dictionaryService from '@/services/dictionary';
import MeaningItem from './MeaningItem.vue';

export default {
    components: {
        UtilsContent,
        MeaningItem,
    },
    computed: {
        ...mapState({
            st: (state) => state.bookReading,
            dictionaryMode: (state) => state.bookReading.dictionaryMode,
            word: (state) => state.bookReading.word,
        }),
    },
    mounted() {
        if (this.dictionaryMode === 'auto') this.search()
    },
    data() {
        return {
            dictionaryImg: require('@/assets/img/icons/reading/icon-diccionary-2.svg'),
            global,
            dictionary_data: [],
            btnLoading: false,
            noMeaning: false,
            notAvailable: false,
        }
    },
    methods: {
        ...mapActions('bookReading', ['setWord']),
        closeDictionary() {
            this.clear()
            this.$emit('close-dictionary')
        },
        clear() {
            this.setWord('')
            this.dictionary_data.length = 0
        },
        onNewSearch() {
            this.btnLoading = true;
            this.dictionary_data.length = 0;
            this.notAvailable = false;
            this.noMeaning = false;
        },
        async search() {
            this.onNewSearch();
            const vm = this;
            const response = await dictionaryService.getMeaning(this.word)
                .catch((error) => Sentry.captureException(error))
                .finally(() => this.btnLoading = false);

            if (!response || response.status.code === 3) {
                this.notAvailable = true;
                return;
            }
            if (response.content === '404') {
                this.noMeaning = true;
                return;
            }
            response.content.results.forEach(item => {
                item.lexicalEntries.forEach(lexicals => {
                    if (lexicals.lexicalCategory.text !== 'Other' && lexicals.entries) {
                        const word = {
                            word: item.word,
                            origin: lexicals.lexicalCategory.text,
                            name: lexicals.lexicalCategory.text,
                            definitions: lexicals.entries[0].senses
                        };
                        vm.dictionary_data.push(word);
                    }
                });
            });
        },
    },
}
</script>
<style>
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
}

.dictionary-content {
    height: 55vh;
    max-height: 55vh;
    overflow: auto;
}
</style>
